module.exports = __webpack_public_path__ + "media/images/faces/face1-4cde3642144b2889248d1b1907d99617.jpg";